import { SUPPORTED_CHAINS } from '@privy-io/react-auth';
import Image from 'next/image';
import { getTransactionExplorerUrl } from 'src/services/zora/helpers/getTransactionExplorerUrl';
import { inTextEllipsisCenter } from 'utils/text-ellipsis-center';
import { CHAIN_DATA } from '../ArticleCollectForm/constants';
import { ArticleIntegrationLink } from '../ArticleIntegrationLink/ArticleIntegrationLink';

export const NftTransactionLink = ({
  contractAddress,
  tokenId,
  chainId,
}: {
  contractAddress: string;
  tokenId: string;
  chainId: number;
}) => (
  <ArticleIntegrationLink
    icon={
      <Image
        src={CHAIN_DATA[chainId as unknown as keyof typeof CHAIN_DATA]?.image}
        height={20}
        width={20}
        alt="Zora icon"
      />
    }
    href={getTransactionExplorerUrl({
      contractAddress,
      tokenId,
      chainId,
    })}
  >
    {SUPPORTED_CHAINS.find((chain) => chain.id === chainId)?.name}: {inTextEllipsisCenter(contractAddress, 15, 15)}
  </ArticleIntegrationLink>
);
